import APIClient from '@/shared/http/clients/api'

const resourceName = 'RELogOccurence'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetLogById = (id, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetLogById/${id}`, config)

const OcurrenceLogRepository = {
  GetLogById
}

export default OcurrenceLogRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/occurencelog.js